import React from 'react';
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import {CaseForms} from "../../../../helpers/enums";
import {useSelector} from "react-redux";
import {useHistory} from "react-router-dom";


const SpidRegisterCase = () => {
  const history = useHistory();
const user = useSelector((state) => state.auth.user);

if (!user) {
  history.push('/login');
}
return (
  <div className="SpidRegisterCase" data-testid="SpidRegisterCase">
    <CaseGenerator
      type={CaseForms.SpidRegister}
      initialValues={
        {
          name: `${user?.name ? user?.name : ''}`,
          surname: `${user?.surname ? user?.surname : ''}`,
          businessName: `${user?.name ? user?.name : ''}`,
          businessSurname: `${user?.surname ? user?.surname : ''}`,
          email: `${user?.email ? user?.email : ''}`,
          confermaEmail: `${user?.email ? user?.email : ''}`,
          codiceFiscale: `${user?.fiscalNumber ? user?.fiscalNumber : ''  }`,
          fiscalCode: `${user?.fiscalNumber ? user?.fiscalNumber : ''  }`,
          emailAziendale: `${user?.email ? user?.email : ''}`,
          confermaEmailAziendale: `${user?.email ? user?.email : ''}`,
          caConfermaEmail: `${user?.email ? user?.email : ''}`,
          caNome: `${user?.name ? user?.name : ''}`,
          caCognome: `${user?.surname ? user?.surname : ''}`,
          pec: `${user?.pec ? user?.pec : ''}`,
          caPec: `${user?.pec ? user?.pec : ''}`,
          piva: `${user?.ivaCode ? user?.ivaCode : ''}`,
          ragioneSociale: `${user?.businessName ? user?.businessName : ''}`,
        }
      }
    />
  </div>
)
};

export default SpidRegisterCase;
